<template>
  <v-container id="fcreate">
    <v-row>
      <v-col cols="12">
        <div
          class="text-h3 mb-2"
          v-text="'Редактирование модификатора ' + getName"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form v-model="valid" ref="form">
          <v-container fluid>
            <v-row>
              <!-- Название -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.name"
                  label="Название"
                  outlined
                  required
                  :rules="rules.required"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                />
              </v-col>
              <!-- Описание -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.description"
                  label="Описание"
                  outlined
                  required
                  :rules="rules.description"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                />
              </v-col>
              <!-- Действие -->
              <v-col cols="12" md="7">
                <v-radio-group
                  v-model="data.action"
                  row
                  :rules="rules.requiredRadioButtonGroup"
                >
                  <template v-slot:label>
                    <div>Выберите действие модификатора:</div>
                  </template>
                  <v-radio value="add" label="Добавить" />
                  <v-radio value="subtract" label="Вычесть" />
                </v-radio-group>
              </v-col>
              <!-- Тип модификатора -->
              <v-col cols="12" md="7">
                <v-radio-group
                  v-model="data.type"
                  row
                  :rules="rules.requiredRadioButtonGroup"
                >
                  <template v-slot:label>
                    <div>Выберите тип модификатора:</div>
                  </template>
                  <v-radio value="single" label="Чекбокс" />
                  <v-radio value="select" label="Тумблер" />
                </v-radio-group>
              </v-col>
              <!-- Price Rate -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.priceRate"
                  label="Price Rate"
                  outlined
                  required
                  :rules="rules.requiredNumber"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                />
              </v-col>
              <!-- Добавочная цена -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.priceAdd"
                  label="Добавочная цена"
                  outlined
                  required
                  :rules="rules.requiredNumber"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                />
              </v-col>
              <!-- Отключ состояние модификатора -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.nameOff"
                  label="Надпись отключенного состояния модификатора"
                  outlined
                  required
                  :rules="rules.required"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                />
              </v-col>
              <!-- Включ состояние модификатора -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.nameOn"
                  label="Надпись включенного состояния модификатора"
                  outlined
                  required
                  :rules="rules.required"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                />
              </v-col>
              <!-- Техническая карта -->
              <v-col cols="12" md="7">
                <v-autocomplete
                  v-model="data.technicalCardId"
                  :items="getTechnicalCardsList"
                  item-text="name"
                  item-value="id"
                  label="Техническая карта"
                  outlined
                  clearable
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Сортировка -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.sortOrder"
                  label="Индекс сортировки"
                  outlined
                  required
                  :rules="rules.requiredNumber"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                />
              </v-col>
              <!-- Submit -->
              <v-col cols="12" md="7">
                <v-btn
                  class="mb-2"
                  block
                  color="primary"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="save"
                >
                  Сохранить
                </v-btn>
                <v-btn
                  class="mb-2"
                  block
                  color="success"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="save(false)"
                >
                  Применить
                </v-btn>
                <v-btn
                  block
                  color="error"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="$router.push('/modifications')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {
          name: '',
          description: '',
          action: 'add',
          type: 'single',
          priceAdd: '',
          priceRate: '',
          nameOn: '',
          nameOff: '',
          technicalCardId: null,
          sortOrder: '1',
          status: true,
        },
        valid: false,
        edit: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
      }
    },
    computed: {
      ...mapGetters({
        getModificationsSingle: 'modifications/getModificationsSingle',
        getTechnicalCardsList: 'technicalCards/getTechnicalCardsList',
      }),
      getId () { return this.$route.params.id || null },
      getName () { return this.getModificationsSingle ? this.getModificationsSingle.name : '' },
    },
    async created () {
      if (this.getId) {
        this.loading = true

        try {
          const res = await this.$store.dispatch('modifications/fetchSingleModifications', this.getId)
          if (res.status === 200) {
            this.editModifications()
          }
        } catch (e) { console.log(e) }

        try {
          await this.$store.dispatch('technicalCards/fetchTechnicalCardsList', {
            limit: 100000,
            offset: 0,
            page: 0,
          })
        } catch (e) { console.log(e) }

        this.loading = false
      } else {
        this.$router.push('/modifications')
      }
    },
    beforeDestroy () {
      this.$store.commit('modifications/clearSingleModifications')
    },
    methods: {
      editModifications () {
        this.edit = true
        this.data = {
          name: this.getModificationsSingle.name,
          description: this.getModificationsSingle.description,
          action: this.getModificationsSingle.action,
          type: this.getModificationsSingle.type,
          priceAdd: this.getModificationsSingle.priceAdd,
          priceRate: this.getModificationsSingle.priceRate,
          nameOn: this.getModificationsSingle.nameOn,
          nameOff: this.getModificationsSingle.nameOff,
          technicalCardId: this.getModificationsSingle.technicalCard ? this.getModificationsSingle.technicalCard.id : null,
          sortOrder: this.getModificationsSingle.sortOrder,
          status: this.getModificationsSingle.status,
        }
      },
      async save (redirect = true) {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loadingForm = true

          try {
            const payload = {
              data: this.data,
              id: this.getId,
            }
            if (!this.data.technicalCardId) {
              payload.data.technicalCardId = null
            }
            payload.data.test = 'test'
            const res = await this.$store.dispatch('modifications/editModifications', payload)
            if (res.status === 200 && redirect) {
              this.$router.push('/modifications')
            } else {
              this.snackbarSuccess = true
              setTimeout(() => {
                this.snackbarSuccess = false
              }, 3000)
            }
          } catch (e) {
            this.loadingForm = false
            console.log(e)
          }
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>

<style scoped>
.v-chip {
  cursor: pointer;
}
</style>
